 
import { Card,Tab, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from '@/components/common/Flex';
import TopKeywordsTable from './TopKeywordsTable';
import SimpleBarReact from 'simplebar-react';
import classNames from 'classnames';
import { FaArrowTrendDown,FaArrowTrendUp } from "react-icons/fa6";


const TabTitle = ({ title,count, icon }) => (
  <Flex className="p-3 ps-2 text-start cursor-pointer gap-1">
    <Flex className="flex-column flex-between-center">
      {icon==='up' ?(
        <>
        <FontAwesomeIcon
          icon="crown"
          className="fs-11 text-warning"
          transform="shrink-4"
        />
        <FaArrowTrendUp className="fs-4"/>
        </>
      ):icon==="down"? <FaArrowTrendDown className="fs-4 mt-auto"/> :''}
    </Flex>
    <div className="ms-2">
      <h6 className="text-700 fs-11 text-nowrap mb-1">{title}</h6>
      <h5 className="mb-0 lh-1">{count}</h5>
    </div>
  </Flex>
);

const TopCourses = ({ tableData, className }) => {

  tableData = [
    {
      title: 'آموزش سئو',
      trainer: '2',
      published: '3',
      enrolled: '-1',
    },
    {
      title: 'آموزش سئو داخلی',
      trainer: '5',
      published: '6',
      enrolled: '-20',
    },
    {
      title: 'آموزش سئو خارجی',
      trainer: '2',
      published: '3',
      enrolled: '-1',
    },
    {
      title: 'آموزش طراحی سایت',
      trainer: '2',
      published: '3',
      enrolled: '-1',
    },
    {
      title: 'آموزش وردپرس',
      trainer: '2',
      published: '3',
      enrolled: '-1',
    },
    
  ];
  return (
    <Card className={classNames(className, 'overflow-hidden')}>
      <Tab.Container id="top-course-tab" defaultActiveKey="popularPaid">
        <SimpleBarReact>
          <Card.Header className="p-0">
            <Nav className="nav-tabs top-courses-tab border-0 flex-nowrap">
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="popularPaid">
                  <TabTitle
                    title="بیشترین رشد"
                    count={4}
                    isActive={true}
                    icon="up"
                  />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="popularFree">
                  <TabTitle
                    title="بیشترین افت"
                    count={20}
                    isActive={false}
                    icon="down"
                  />
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="mb-0" eventKey="topPaid">
                <FontAwesomeIcon icon="fa fa-fire" className="fs-7 mt-auto"/>
                  <TabTitle
                    title="بدون تغییر"
                    count={10}
                    isActive={false}
                    icon="fire"
                  />
                </Nav.Link>
              </Nav.Item>
              {/* <Nav.Item>
                <Nav.Link className="mb-0" eventKey="topFree">
                  <TabTitle
                    title="Top Rated"
                    isPaid={false}
                    isActive={false}
                    icon="star"
                  />
                </Nav.Link>
              </Nav.Item> */}
            </Nav>
          </Card.Header>
        </SimpleBarReact>

        <Card.Body className="p-0">
          <Tab.Content className='mb-4'>
            <Tab.Pane unmountOnExit eventKey="popularPaid">
              <TopKeywordsTable tableData={tableData.slice(0, 4)}/>
            </Tab.Pane>
            <Tab.Pane unmountOnExit eventKey="popularFree">
              <TopKeywordsTable tableData={tableData.slice(4, 8)} />
            </Tab.Pane>
            <Tab.Pane unmountOnExit eventKey="topPaid">
              <TopKeywordsTable tableData={tableData.slice(8, 12)} />
            </Tab.Pane>
            {/* <Tab.Pane unmountOnExit eventKey="topFree">
              <TopCoursesTable tableData={tableData.slice(12, 16)} />
            </Tab.Pane> */}
          </Tab.Content>
        </Card.Body>
      </Tab.Container>
    </Card>
  );
};



export default TopCourses;
